import { onDelete } from "../../../function/onDelete";
import { deleteOffer } from "./query";

export default async function onDeleteOffer({
  selectionModel,
  setSelectionModel,
  client,
  values,
}) {
  if (selectionModel) {
    await Promise.all(
      selectionModel?.map(async (items) => {
        await deleteSingleItem(items, client);
      })
    );
    setSelectionModel && setSelectionModel([]);
  } else if (values) {
    await deleteSingleItem(values, client);
  }
}

async function deleteSingleItem(item, client) {
  // console.log({ item, client });
  const { id, number } = item || {};

  await onDelete({
    input: { id },
    mutation: deleteOffer,
    // updateCacheFields: ["relationsByCustomerID"],
    client,
    storagePath: number,
  });
}
